import { ArrowDownWideNarrow, Check } from 'lucide-react';

import { Button } from '@/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  ROUTE_SORT_TYPE_BEST,
  ROUTE_SORT_TYPE_CO2,
  ROUTE_SORT_TYPE_DISTANCE,
  ROUTE_SORT_TYPE_DURATION,
  ROUTE_SORT_TYPE_FREQUENCY,
} from '@/lib/constants';
import { OptionItem, RouteSortTypes } from '@/types';
import { trackUser } from '@/utils/tracking';

const routeSortOptions: OptionItem[] = [
  { value: ROUTE_SORT_TYPE_BEST, label: 'Best route' },
  { value: ROUTE_SORT_TYPE_DURATION, label: 'Fastest' },
  { value: ROUTE_SORT_TYPE_CO2, label: 'Lowest emissions' },
  { value: ROUTE_SORT_TYPE_FREQUENCY, label: 'Highest frequency' },
  { value: ROUTE_SORT_TYPE_DISTANCE, label: 'Shortest distance' },
];

export interface RouteSortOptionsProps {
  sortValue?: RouteSortTypes;
  onSortingChange: (value: RouteSortTypes) => void;
}

const RouteSortOptions = ({ sortValue, onSortingChange }: RouteSortOptionsProps) => {
  const handleSortChange = (val: string) => {
    onSortingChange(val as RouteSortTypes);

    trackUser.event('Route Sorting: Changed', {
      value: val,
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="small"
          variant="outline"
          className="flex h-7 px-2"
          iconLeft={<ArrowDownWideNarrow className="size-3.5" />}
        >
          Sort
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-white">
        <DropdownMenuLabel>Sort by</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={sortValue} onValueChange={handleSortChange}>
          {routeSortOptions.map((col) => {
            return (
              <DropdownMenuRadioItem key={col.value} value={col.value} indicatorIcon={<Check />}>
                {col.label}
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export { RouteSortOptions };
